import { Navigate, Route, Routes, useParams } from "react-router-dom"
import EventLayout from "./layout"
import Monitors from "./monitors"
import Members from "./members"
import NoMatch from "components/no-match"
// import MemberDetail from "./members/show"
// import Accidents from "./members/accidents"
// import AccidentDetail from "./members/accidents/show"
import EventMonitoring from "pages/event-monitoring"

const Events: React.FC = () => (
  <Routes>
    <Route index element={<EventMonitoring />} />
    <Route path=":eventId">
      <Route element={<EventLayout />}>
        <Route index element={<Navigate to="monitors" replace />} />
        <Route path="monitors" element={<Monitors />} />
        <Route path="members/*">
          <Route index element={<Members />} />
          {/* <Route path=":presenceId/*">
            <Route index element={<MemberDetail />} />
            <Route path="accidents/*">
              <Route index element={<Accidents />} />
              <Route path=":accidentId" element={<AccidentDetail />} />
            </Route>
          </Route> */}
        </Route>
      </Route>

      <Route path="*" element={<NoMatch />} />
    </Route>
  </Routes>
)

export function useEventId() {
  return useParams<"eventId">().eventId
}

export function usePresenceId() {
  return useParams<"presenceId">().presenceId
}

export function useAccidentId() {
  return useParams<"accidentId">().accidentId
}

export default Events
